"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTranslations = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var withTranslations,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

exports.withTranslations = withTranslations;

exports.withTranslations = withTranslations = function withTranslations(t, Comp) {
  var WithTranslations, WrappedComp;
  WrappedComp = (0, _reactIntl.injectIntl)(Comp);
  return (0, _reactIntl.injectIntl)(WithTranslations = function () {
    var WithTranslations =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(WithTranslations, _React$Component);

      function WithTranslations() {
        var _this;

        _classCallCheck(this, WithTranslations);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(WithTranslations).apply(this, arguments));
        _this.formatMessage = _this.formatMessage.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(WithTranslations, [{
        key: "formatMessage",
        value: function formatMessage(key, fallback) {
          var messages, ref;
          boundMethodCheck(this, WithTranslations);
          messages = t[(ref = this.props.intl) != null ? ref.locale : void 0] || {};
          return messages[key] || fallback;
        }
      }, {
        key: "render",
        value: function render() {
          var messages, ref;
          messages = t[(ref = this.props.intl) != null ? ref.locale : void 0] || {};
          return _react.default.createElement(_reactIntl.IntlProvider, {
            messages: messages
          }, _react.default.createElement(WrappedComp, Object.assign({}, this.props, {
            formatMessage: this.formatMessage
          })));
        }
      }]);

      return WithTranslations;
    }(_react.default.Component);

    ;
    WithTranslations.propTypes = Comp.propTypes;
    WithTranslations.displayName = "WithTranslations(".concat(Comp.displayName || Comp.name || 'Component', ")");
    return WithTranslations;
  }.call(this));
};